/**
 * Created by avaldez on 12/20/16.
 */
import Footer from './Footer';

export default Footer;